import { render, staticRenderFns } from "./personal-trade-select.vue?vue&type=template&id=3da44b90&"
import script from "./personal-trade-select.vue?vue&type=script&lang=js&"
export * from "./personal-trade-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports